<section class="widget-section order-1">
  <div class="container-fluid">
    <div class="hero-zone-infobox" #heroZoneInfoBoxContainer>
      <app-infobox-zone appMarkComponentVisited area="Hero" [appHideParentIfEmpty]="heroZoneInfoBoxContainer">
      </app-infobox-zone>
    </div>
  </div>
</section>
<section class="widget-section order-2">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
    <app-my-app-tiles appMarkComponentVisited></app-my-app-tiles>
  </div>
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" #smartLinksContainer>
    <app-smart-links [appHideParentIfEmpty]="smartLinksContainer" appMarkComponentVisited data-notsortable="true"></app-smart-links>
  </div>
</section>

<section class="widget-section order-3">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
    <app-featured-news appMarkComponentVisited></app-featured-news>
  </div>
</section>

<section class="widget-section order-4">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
    <app-my-news></app-my-news>
  </div>
</section>

<section class="widget-section order-5" id="info-box">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" #infoBoxContainer>
    <app-infobox-zone appMarkComponentVisited area="Default" [appHideParentIfEmpty]="infoBoxContainer"></app-infobox-zone>
  </div>
</section>

<section class="widget-section order-6" id="app-kpi-charts">
    <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" #kpiContainer>
       <app-kpi-charts [appHideParentIfEmpty]="kpiContainer"></app-kpi-charts>
    </div>
</section>
